import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.jsx';
import { ErrorBoundary } from './ui/ErrorBoundary.js';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  /*
    The outermost boundary, above `App` rather than inside it.

    Inside, it could only catch what `App` renders — not `App` itself, and not the store subscription
    that runs on the way to its first render. A boundary that cannot catch its own host is the one
    case that still produces the white screen it exists to prevent.
  */
  <StrictMode>
    <ErrorBoundary scope="app">
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
